import type { Control, FieldValues } from "react-hook-form";

import type { FormSectionProps } from "~/components/formElements/FormSection";
import FormSection from "~/components/formElements/FormSection";
import Input from "~/components/formElements/Input";

type TitleFormSectionProps<T extends FieldValues> = FormSectionProps & {
	control: Control<T>;
};

const TitleFormSection = <T extends FieldValues>({ control, title }: TitleFormSectionProps<T>) => {
	return (
		<FormSection title={title}>
			<div className="grid grid-cols-6 gap-x-6 gap-y-2">
				<div className="col-span-6">
					<Input
						name="title"
						control={control}
						placeholder="Titel"
					/>
				</div>
			</div>
		</FormSection>
	);
};

export default TitleFormSection;
